import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../navigation/AuthenticationStateManager";
import Icon from "../AppIcon";

const AdminHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/authentication-portal", { replace: true });
  };

  return (
    <header className="h-16 bg-card border-b border-border px-6 flex items-center justify-between">
    <img
              src="/assets/images/Logo_Botervue.png"
              alt="Botervue"
              className="w-[140px] md:w-[180px] h-auto object-contain"
            />

      <div className="flex items-center gap-4">
        <span className="text-sm text-muted-foreground">{user?.email}</span>
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium
            text-red-600 hover:bg-red-50"
        >
          <Icon name="LogOut" size={18} />
          Logout
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;
